var render, staticRenderFns
import script from "./RewardSetting.vue?vue&type=script&lang=js"
export * from "./RewardSetting.vue?vue&type=script&lang=js"
import style0 from "./RewardSetting.vue?vue&type=style&index=0&id=ffb955bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb955bc",
  null
  
)

export default component.exports